import { DELIVERY, GUARANTEE_DAYS } from './offer'

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a curriculum? Will it clash with how we already homeschool?',
    answer:
      'Zero academic content, on purpose. No subjects, no lesson plans, no opinions about what or how you teach. This is the operations layer that wraps around whatever you already use — structured, classical, relaxed, unit studies, all of it. If your homeschool were a business, this wouldn’t be the product on the shelves. It’d be the back office that keeps the doors open.',
  },
  {
    question:
      'Three hundred pages? I don’t have time to read a book about getting organized.',
    answer:
      'You’re not meant to read it. These are templates to print and use, and the volumes are standalone — you open the one today’s problem belongs to. Bonus 1 is a single sheet that takes you from purchase to your first finished reset in twenty minutes, without reading anything else.',
  },
  {
    question: 'I’ve abandoned planners before. Why would this be different?',
    answer:
      'Because abandonment is the design brief, not an edge case. Margin weeks are scheduled in advance instead of hoped for. Days run on three or four anchors instead of hour-by-hour slots that break at 9 a.m. There’s a card for the day that falls apart, a ladder for the season that gets heavy, and a twenty-minute reset that restarts everything after any off stretch. Nothing here assumes you’ll be consistent. It assumes you’ll be interrupted.',
  },
  {
    question: 'Will this fit what’s required where I live?',
    answer:
      'It’s built to be adapted rather than to assume. Every log is a blank, configurable field set: nothing pre-filled, nothing named for you. You decide what goes in it, and there’s a checkpoint in the record-keeping volume telling you to check your local requirements before you finalize your fields. This is an organization tool, not a legal one — it never tells you what to file and never claims anything on your behalf.',
  },
  {
    question: 'I can find free printables for all of this.',
    answer:
      'You can find pieces — scattered across hundreds of pins and posts, in a dozen visual styles, with no order between them. What you can’t download for free is the sequence: what to decide first, what feeds what, and what to do on the week it all falls over. You’re not paying for pages. You’re paying for a system that has already made those decisions.',
  },
  {
    question: 'Is it dated? Can I start in the middle of the year?',
    answer:
      'Everything is undated, and the year is planned in blocks rather than months, so there’s no wrong week to start. That’s also why it works no matter which month your school year begins in.',
  },
  {
    question: 'How do I get it, and what do I need to use it?',
    answer: `Instant download after checkout — ${DELIVERY}. Both standard paper sizes ship together — use the file that matches the paper in your printer. Everything is ink-friendly: no heavy fills, no photos, no color required. A home printer, a pencil, and a fridge is the whole equipment list.`,
  },
  {
    question: 'What if it’s not for me?',
    answer: `${GUARANTEE_DAYS}-day guarantee. Full refund, no questions asked.`,
  },
]
